import { EventWorker } from '../services/EventWorker';

export const MAX_WORKERS = Math.min(navigator.hardwareConcurrency || 4, 4);

let instances: EventWorker[];

export const launchMediaWorkers = (): EventWorker[] => {
  if (!instances) {
    instances = new Array(MAX_WORKERS).fill(undefined).map(() => {
      const worker = new Worker(new URL('../rLottie.worker.ts', import.meta.url));
      return new EventWorker(worker);
    });
  }

  return instances;
};
